import * as angular from 'angular';
import { RedemptionBulkUpdateService } from './bulk-update/bulk-update.service';
import RedemptionBulkUpdateComponent from './bulk-update/bulk-update.component';
import RedemptionService from './redemption.service';
import redemptionsRouter from './redemptions.router';

/** @constant {angular.module} */
const redemptionsModule = angular
  .module('ec.opsCenter.redemptions', [])
  .config(redemptionsRouter)
  .component('ocRedemptionBulkUpdate', RedemptionBulkUpdateComponent)
  .service('redemptionBulkUpdateService', RedemptionBulkUpdateService)
  .service('RedemptionService', RedemptionService).name;

export default redemptionsModule;



// WEBPACK FOOTER //
// ./src/app/redemptions/redemptions.module.ts